import { render, staticRenderFns } from "./CreateWarehouseModal.vue?vue&type=template&id=56a7cce6&scoped=true&"
import script from "./CreateWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./CreateWarehouseModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateWarehouseModal.vue?vue&type=style&index=0&id=56a7cce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7cce6",
  null
  
)

export default component.exports